/**
 * @component PasswordVerifyModal
 * @description 비즈니스 목적: 문의 열람 전 비밀번호를 확인하는 모달 UI를 제공한다.
 */

export default function PasswordVerifyModal({
  errorMessage,
  isOpen,
  isSubmitting,
  onCancel,
  onChangePassword,
  onConfirm,
  password,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" role="presentation">
      <div className="modal-popup" role="dialog" aria-modal="true" aria-labelledby="password-verify-title">
        <h2 id="password-verify-title" className="modal-popup-title">
          {'비밀번호 확인'}
        </h2>

        <div className="password-verify-field">
          {/* 기능 설명: 사용자가 입력한 비밀번호를 서버 검증 API 요청 바디에 사용한다. */}
          <input
            type="password"
            value={password}
            onChange={onChangePassword}
            className={`password-verify-input ${errorMessage ? 'is-error' : ''}`}
            placeholder={'비밀번호를 입력해 주세요.'}
            autoComplete="current-password"
          />
          <p className="password-verify-error">{errorMessage || ' '}</p>
        </div>

        <div className="modal-popup-actions modal-popup-actions-dual">
          <button type="button" className="secondary-button" onClick={onCancel} disabled={isSubmitting}>
            {'취소'}
          </button>
          <button type="button" className="primary-button" onClick={onConfirm} disabled={isSubmitting}>
            {isSubmitting ? '확인 중...' : '확인'}
          </button>
        </div>
      </div>
    </div>
  );
}
